import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Bookmark = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 24V0H21V24L12 17.993L3 24ZM20 1H4V22.1303L12 16.7908L20 22.1303V1Z"
  />,
  'Bookmark'
)

export default Bookmark
